<template>
  <div class="section section1">
    <h2 class="fs24 fs-rem28 c-black sec-tit">
      <em></em>资源匹配
    </h2>
    <div class="w1200">
      <div class="sec1-list">
        <ul class="list-box">
          <li class="lst-item lst-item1">
            <router-link :to="{name: 'Policy'}">
              <i class="icon1 icon11"></i>
              <h3 class="fs-rem26 h3tit">看政策</h3>
            </router-link>
          </li>
          <li class="lst-item lst-item2">
            <router-link :to="{name: 'ProjectFind'}">
              <i class="icon1 icon12"></i>
              <h3 class="fs-rem26 h3tit">查项目</h3>
            </router-link>
          </li>
          <li class="lst-item lst-item5">
            <router-link :to="{name: 'VSpecialist'}">
              <i class="icon1 icon15"></i>
              <h3 class="fs-rem26 h3tit">聘专家</h3>
            </router-link>
          </li>
          <li class="lst-item lst-item6">
             <router-link :to="{name: 'Standard'}">
              <i class="icon1 icon16"></i>
              <h3 class="fs-rem26 h3tit">创标准</h3>
            </router-link>
          </li>
          <li class="lst-item lst-item3 cursor-point" @click="noneOpen">
            <!-- <router-link :to="{name: 'Financial'}"> -->
              <i class="icon1 icon13"></i>
              <h3 class="fs-rem26 h3tit">找资金</h3>
            <!-- </router-link> -->
          </li>
          <li class="lst-item lst-item4 cursor-point" @click="noneOpen">
            <!-- <router-link :to="{name: 'Financial'}"> -->
              <i class="icon1 icon14"></i>
              <h3 class="fs-rem26 h3tit">获担保</h3>
            <!-- </router-link> -->
          </li>
        </ul>
        <div class="c-white my-proj" @click="$router.push('/personal-center/profile')">
          <h1 class="fs24 h1tit">我的项目</h1>
          <div class="proj-item">
            <p class="fs30 num">{{projectSignup.createdProjectCount}}</p>
            <p class="fs18 tit">发布需求</p>
          </div>
          <div class="proj-item">
            <p class="fs30 num">{{projectSignup.singupProjectCount}}</p>
            <p class="fs18 tit">需求报名</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /资源匹配 -->
</template>

<script>
import { getCacheUserInfo } from '@/utils/auth';
export default {
  name: 'MainData',
  props: {
    msg: String,
  },
  data() {
    return {
      projectSignup:{
        createdProjectCount:0,
        singupProjectCount:0
      }
    }
  },
  mounted() {
    let userinfo = getCacheUserInfo()
    if(userinfo.projectSignup){
      this.projectSignup = getCacheUserInfo().projectSignup
    }else{
      this.projectSignup.createdProjectCount=0;
      this.projectSignup.singupProjectCount=0;
    }
  },

  methods:{
    noneOpen(){
      this.$message.error('暂未开放')
    }
  }

};
</script>

<style scoped>
@import url(./MainData.css);
.cursor-point {

  cursor: hand;  /*鼠标悬停变小手*/

}

</style>
